import { useSmartTipsQuery } from '../queries/useSmartTipsQuery';

interface GuestSmartTipsOptions {
    useAssistantApi?: boolean;
    queryEnabled?: boolean;
}

/**
 * Hook for fetching guest smart tips with configurable API backend during migration (Assistant → GX AI)
 */
export const useGuestSmartTips = (guestId: string, options: GuestSmartTipsOptions = {}) => {
    const { useAssistantApi = true, queryEnabled = true } = options;

    const { data: smartTipsResponse, isFetching, error } = useSmartTipsQuery(guestId, useAssistantApi, queryEnabled);

    return {
        smartTipsResponse,
        error,
        isFetching,
    };
};
